"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var constants_1 = require("../constants");
var utils_1 = require("../utils");
var MainFilter = function (_a) {
    var searchParams = _a.searchParams, setSearchParams = _a.setSearchParams, isLoading = _a.isLoading, brands = _a.brands, categories = _a.categories, provinces = _a.provinces;
    var _b = react_1.useState({ min: null, max: null }), tempRange = _b[0], setTempRange = _b[1];
    // const [categories, setCategories] = useState<Category.RootObject[]>();
    // const [provinces, setProvinces] = useState<Provinces.RootObject[]>();
    var _c = react_1.useState(false), mobileShowFilter = _c[0], setMobileShowFilter = _c[1];
    var _d = react_1.useState(false), mobileShowOrder = _d[0], setMobileShowOrder = _d[1];
    var _e = react_1.useState(false), showAllCate = _e[0], setShowAllCate = _e[1];
    var _f = react_1.useState(false), showAllBrand = _f[0], setShowAllBrand = _f[1];
    var _g = react_1.useState(false), showAllLokasi = _g[0], setShowAllLokasi = _g[1];
    var _h = react_1.useState(false), errorRange = _h[0], setErrorRange = _h[1];
    var handleRangeFilterSubmit = function (e) {
        var _a, _b;
        e.preventDefault();
        var max = null;
        if (tempRange.max !== null && Number(tempRange.max) >= 0) {
            max = Number((_a = tempRange.max) === null || _a === void 0 ? void 0 : _a.replace(".", ""));
        }
        var min = Number((_b = tempRange.min) === null || _b === void 0 ? void 0 : _b.replace(".", ""));
        setSearchParams(__assign(__assign({}, searchParams), { maxrange: max, minrange: min }));
    };
    react_1.useEffect(function () {
        // fetchCategories().then((res) => setCategories(res.data));
        // fetchProvinces().then((res) => setProvinces(res.data));
    }, []);
    react_1.useEffect(function () {
        if ((searchParams === null || searchParams === void 0 ? void 0 : searchParams.maxrange) || (searchParams === null || searchParams === void 0 ? void 0 : searchParams.minrange)) {
            setTempRange({
                max: Number(searchParams.maxrange) > 0 ? String(searchParams.maxrange) : null,
                min: Number(searchParams.minrange) > 0 ? String(searchParams.minrange) : null,
            });
        }
    }, [searchParams]);
    var handleRangeChange = function (e, mode) {
        var _a;
        var newRange;
        // let condition;
        // if (mode === "min") {
        //     condition =
        //         Number(removeSymbols(e.target.value)) > Number(tempRange.max);
        // } else {
        //     condition =
        //         Number(removeSymbols(e.target.value)) < Number(tempRange.min);
        // }
        // if (condition) {
        //     newRange = {
        //         min: removeSymbols(e.target.value),
        //         max: removeSymbols(e.target.value),
        //     };
        // } else {
        //     newRange = {
        //         ...tempRange,
        //         [mode]: removeSymbols(e.target.value),
        //     };
        // }
        newRange = __assign(__assign({}, tempRange), (_a = {}, _a[mode] = Number(e.target.value) > 0 ? utils_1.removeSymbols(e.target.value) : null, _a));
        setTempRange(newRange);
    };
    react_1.useEffect(function () {
        setErrorRange(false);
        if (Number(tempRange.min) > 0 && Number(tempRange.max) > 0) {
            if (Number(tempRange.max) < Number(tempRange.min)) {
                setErrorRange(true);
            }
        }
    }, [tempRange]);
    var handleCheckFilter = function (e, mode) {
        var _a, _b;
        if (searchParams) {
            var newData = [];
            var newParam = searchParams;
            if (e.target.checked === true) {
                if (!searchParams[mode]) {
                    newData = [e.target.value];
                }
                else {
                    newData = __spreadArray(__spreadArray([], searchParams[mode].split(",")), [
                        e.target.value,
                    ]);
                }
                newParam = __assign(__assign({}, searchParams), (_a = {}, _a[mode] = newData.join(","), _a));
            }
            else if (e.target.checked === false) {
                if (searchParams[mode]) {
                    //@ts-ignore
                    newData = searchParams[mode].split(",");
                    newData = newData.filter(function (cat) { return cat !== e.target.value; });
                    newParam = __assign(__assign({}, searchParams), (_b = {}, _b[mode] = newData.join(","), _b));
                    if (newData.length === 0) {
                        delete newParam[mode];
                    }
                }
            }
            //Reset pagination tiap perubahan filter
            delete newParam.pg;
            //Reset filter brand kalau kategori berubah
            if (mode === "category") {
                delete newParam.brand_id;
            }
            setSearchParams(newParam);
        }
    };
    var _showAll = function (val) {
        if (val == 'cate') {
            setShowAllCate(true);
        }
        else if (val == 'brand') {
            setShowAllBrand(true);
        }
        else {
            setShowAllLokasi(true);
        }
    };
    return (react_1.default.createElement("div", { className: "col-md-3 col_shop_filter" },
        react_1.default.createElement("div", { className: "filter_shops animated " + (mobileShowFilter ? "show" : "") },
            react_1.default.createElement("div", { className: "ht_subfitler2 mob_display" },
                "Filter",
                react_1.default.createElement("span", { className: "hide_mobfilter", onClick: function () {
                        setMobileShowFilter(false);
                        setMobileShowOrder(false);
                    } }, "Tutup")),
            react_1.default.createElement("div", { className: "bx_subfilter_sp second_subfilter" },
                react_1.default.createElement("div", { className: "f_header" }, "Filter"),
                react_1.default.createElement("div", { className: "ht_subfitler" }, "Rentangan Harga"),
                react_1.default.createElement("form", { onSubmit: handleRangeFilterSubmit },
                    react_1.default.createElement("div", { className: "f_subfilter" },
                        react_1.default.createElement("span", null, "Rp"),
                        react_1.default.createElement("input", { type: "text", className: "txt_subfilter", name: "minrange", placeholder: "Minimum", onChange: function (e) {
                                handleRangeChange(e, "min");
                            }, value: tempRange.min
                                ? Number(tempRange.min).toLocaleString("id-ID")
                                : "" }),
                        react_1.default.createElement("div", { id: "err_minimum", className: "f_err" })),
                    react_1.default.createElement("div", { className: "f_subfilter" },
                        react_1.default.createElement("span", null, "Rp"),
                        react_1.default.createElement("input", { type: "text", className: "txt_subfilter", name: "maxrange", placeholder: "Maksimum", onChange: function (e) {
                                handleRangeChange(e, "max");
                            }, value: tempRange.max
                                ? Number(tempRange.max).toLocaleString("id-ID")
                                : "" }),
                        react_1.default.createElement("div", { id: "err_minimum", className: "f_err" })),
                    react_1.default.createElement("span", { className: errorRange ? '' : 'hide', style: { fontSize: '12px', color: 'red' } }, "Harga maksimum harus lebih besar dari harga minimum."),
                    react_1.default.createElement("input", { type: "submit", className: "sub_subfilter", value: "Terapkan Harga", disabled: isLoading || errorRange })),
                categories && categories.length > 0 && (react_1.default.createElement(react_1.Fragment, { key: Math.random() * 10 },
                    react_1.default.createElement("div", { className: "breaker" }),
                    react_1.default.createElement("div", { className: "ht_subfitler" }, "Kategori"),
                    react_1.default.createElement("div", { className: "bx_subfilter_in" },
                        searchParams &&
                            (categories === null || categories === void 0 ? void 0 : categories.map(function (category, index) {
                                var _a;
                                return (react_1.default.createElement("div", { key: Math.random() * 10, className: "f_aform f_aform_brand cate_hidden", style: { display: showAllCate || index < 7 ? 'block' : 'none' } },
                                    react_1.default.createElement("label", { className: "cont_check" },
                                        category.title,
                                        react_1.default.createElement("input", { checked: searchParams.category
                                                ? (_a = searchParams.category) === null || _a === void 0 ? void 0 : _a.split(",").includes(String(category.id))
                                                : false, type: "checkbox", value: category.id, onChange: function (e) {
                                                handleCheckFilter(e, "category");
                                            } }),
                                        react_1.default.createElement("span", { className: "checkmark" }))));
                            })),
                        categories.length > 7 && !showAllCate ? (react_1.default.createElement("div", { onClick: function () { return _showAll('cate'); }, style: { cursor: 'pointer' } },
                            react_1.default.createElement("span", null,
                                react_1.default.createElement("strong", null, "Lainnya")))) : null))),
                brands && brands.length > 0 && (react_1.default.createElement(react_1.Fragment, { key: Math.random() * 10 },
                    react_1.default.createElement("div", { className: "breaker" }),
                    react_1.default.createElement("div", { className: "ht_subfitler" }, "Brand"),
                    react_1.default.createElement("div", { className: "bx_subfilter_in" },
                        searchParams &&
                            (brands === null || brands === void 0 ? void 0 : brands.map(function (brand, index) { return (react_1.default.createElement("div", { key: Math.random() * 10, className: "f_aform f_aform_brand", style: { display: showAllBrand || index < 7 ? 'block' : 'none' } },
                                react_1.default.createElement("label", { className: "cont_check" },
                                    brand.title,
                                    react_1.default.createElement("input", { checked: searchParams.brand_id
                                            ? searchParams.brand_id
                                                .split(",")
                                                .includes(String(brand.id))
                                            : false, type: "checkbox", value: brand.id, onChange: function (e) {
                                            handleCheckFilter(e, "brand_id");
                                        } }),
                                    react_1.default.createElement("span", { className: "checkmark" })))); })),
                        brands.length > 7 && !showAllBrand ? (react_1.default.createElement("div", { onClick: function () { return _showAll('brand'); }, style: { cursor: 'pointer' } },
                            react_1.default.createElement("span", null,
                                react_1.default.createElement("strong", null, "Lainnya")))) : null))),
                provinces && provinces.length > 0 && (react_1.default.createElement(react_1.Fragment, { key: Math.random() * 10 },
                    react_1.default.createElement("div", { className: "breaker" }),
                    react_1.default.createElement("div", { className: "ht_subfitler" }, "Lokasi"),
                    react_1.default.createElement("div", { className: "bx_subfilter_in" },
                        searchParams &&
                            (provinces === null || provinces === void 0 ? void 0 : provinces.map(function (province, index) { return (react_1.default.createElement("div", { key: Math.random() * 10, className: "f_aform f_aform_brand", style: { display: showAllLokasi || index < 7 ? 'block' : 'none' } },
                                react_1.default.createElement("label", { className: "cont_check" },
                                    province.title,
                                    react_1.default.createElement("input", { checked: searchParams.province
                                            ? searchParams.province
                                                .split(",")
                                                .includes(String(province.id))
                                            : false, type: "checkbox", value: province.id, onChange: function (e) {
                                            handleCheckFilter(e, "province");
                                        } }),
                                    react_1.default.createElement("span", { className: "checkmark" })))); })),
                        provinces.length > 7 && !showAllLokasi ? (react_1.default.createElement("div", { onClick: function () { return _showAll('lokasi'); }, style: { cursor: 'pointer' } },
                            react_1.default.createElement("span", null,
                                react_1.default.createElement("strong", null, "Lainnya")))) : null))))),
        react_1.default.createElement("div", { className: "fix_btnfilter_mob mob_display" },
            react_1.default.createElement("a", { id: "open_mob_shopsort", className: "a_mobfil_urutkan", onClick: function () { return setMobileShowOrder(!mobileShowOrder); } }, "Urutkan"),
            react_1.default.createElement("span", null, "|"),
            react_1.default.createElement("a", { onClick: function () { return setMobileShowFilter(!mobileShowFilter); }, className: "a_mobfil_filter" }, "Filter")),
        react_1.default.createElement("div", { className: "bx_mob_sortby mob_display " + (mobileShowOrder ? "show" : "") },
            react_1.default.createElement("div", { className: "bx_mob_insortby" },
                react_1.default.createElement("div", { className: "ht_mob_sortby" }, "Urutkan Berdasarkan:"),
                react_1.default.createElement("ul", { className: "ul_mob_sortby_new" }, constants_1.filters.map(function (filter) { return (react_1.default.createElement("li", { key: Math.random() * 10, className: "" + (filter.value === (searchParams === null || searchParams === void 0 ? void 0 : searchParams.by)
                        ? "act"
                        : ""), onClick: function () {
                        setMobileShowOrder(false);
                        setSearchParams(__assign(__assign({}, searchParams), { by: filter.value }));
                    } },
                    react_1.default.createElement("a", null, filter.label))); })),
                react_1.default.createElement("input", { type: "button", className: "sub_subfilter close_mob_sortby", value: "Tutup", onClick: function () { return setMobileShowOrder(!mobileShowOrder); } })))));
};
exports.default = MainFilter;
